import _forEach from 'lodash/forEach';

import { LayerAlignmentItem, LayerPatternItem } from 'interfaces/calculator';
import { LayerAlignmentType, LayerPatternType } from 'enums/calculator';

import { ReactComponent as HMirroredIcon } from 'images/icons/layer-alignment/h-mirrored.svg';
import { ReactComponent as VMirroredIcon } from 'images/icons/layer-alignment/v-mirrored.svg';
import { ReactComponent as RotatedIcon } from 'images/icons/layer-alignment/rotated.svg';
import { ReactComponent as Parallel } from 'images/icons/layer-alignment/parallel.svg';

interface Keys {
  [key: string]: Array<number>;
}

const baseData: Keys = {
  a: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 18],
  b: [4, 6, 9, 12, 13],
  c: [8, 10, 20],
  d: [6, 8, 9, 16],
  j: [10],
};

const makePatternsData = (): LayerPatternItem[] => {
  const data: LayerPatternItem[] = [];
  Object.keys(baseData).forEach((key) => {
    const dataKey = baseData[key];
    _forEach(dataKey, (value) => {
      const label = `${value}${key.toUpperCase()}`;
      data.push({
        value,
        label,
      });
    });
  });

  data.sort((a, b) => Number(b.value) - Number(a.value));
  data.unshift({ value: 0, label: 'Grid' });
  return data;
};

const items = makePatternsData();

const alignmentItems: LayerAlignmentItem[] = [
  {
    id: LayerAlignmentType.H_MIRRORED,
    label: 'H-mirrored',
    Icon: HMirroredIcon,
  },
  {
    id: LayerAlignmentType.V_MIRRORED,
    label: 'V-mirrored',
    Icon: VMirroredIcon,
  },
  {
    id: LayerAlignmentType.ROTATED,
    label: 'Rotated',
    Icon: RotatedIcon,
  },
  {
    id: LayerAlignmentType.PARALLEL,
    label: 'Parallel',
    Icon: Parallel,
    selected: true,
  },
];

const layerDefaultState = {
  units: null,
  pattern: {
    type: LayerPatternType.ALIGNED,
    items,
    activeItem: items && items[0],
  },
  alignmentItems,
  horizontalOverlap: 0,
  verticalOverlap: 0,
};

export default layerDefaultState;
